type GeoLocationResult =
	| {
			status: "success";
			latitude: number;
			longitude: number;
			accuracy: number; // meters
			timestamp: number; // epoch ms
	  }
	| {
			status: "denied" | "timeout" | "unavailable" | "unsupported";
			errorMessage: string;
	  };

export const GeoLocationService = {
	async getCurrentPosition(options: { timeoutMs?: number; maximumAgeMs?: number } = {}): Promise<GeoLocationResult> {
		if (!("geolocation" in navigator)) {
			return {
				status: "unsupported",
				errorMessage: "Geolocation is not supported on this device.",
			};
		}

		return new Promise((resolve) => {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					resolve({
						status: "success",
						latitude: position.coords.latitude,
						longitude: position.coords.longitude,
						accuracy: position.coords.accuracy,
						timestamp: position.timestamp,
					});
				},
				(error) => {
					switch (error.code) {
						case error.PERMISSION_DENIED:
							resolve({
								status: "denied",
								errorMessage: "Location access was denied.",
							});
							break;

						case error.TIMEOUT:
							resolve({
								status: "timeout",
								errorMessage: "Unable to get a GPS fix. Please try again.",
							});
							break;

						default:
							resolve({
								status: "unavailable",
								errorMessage: "Location data is unavailable.",
							});
					}
				},
				{
					enableHighAccuracy: true,
					timeout: options.timeoutMs ?? 15000,
					maximumAge: options.maximumAgeMs ?? 0,
				},
			);
		});
	},
};
